export default "__VITE_ASSET__BwRHccPY__"